import React from "react";
import { Container } from "reactstrap";

const SuperAdminDashboard = () => {
  document.title = "Dashboard | Ancile Services";

  return (
    <div className="page-content">
      <Container
        fluid
        className="d-flex align-items-center justify-content-center"
        style={{ minHeight: "calc(100vh - 180px)" }}
      >
        <h3 className="text-muted mb-0">Under Maintenance</h3>
      </Container>
    </div>
  );
};

export default SuperAdminDashboard;
